import { createSlice } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
// utils
import axios from "../../utils/axios";
import { PATH_DASHBOARD } from "../../routes/paths";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  countries: [],
  fetchLoading: false,
};

const slice = createSlice({
  name: "country",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getFaqSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.countries = action.payload;
    },
  },
});

export default slice.reducer;

export function getCountries() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("countries");
      dispatch(slice.actions.getFaqSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
